import { PageCriteria } from '@src/main/shared/domain/page-criteria.interface';

export interface InboxMessageCriteria extends PageCriteria {
  attachment?: boolean;
  message?: string;
  recipient?: string;
  sendBy?: string;
  sendDateFrom?: string;
  sendDateTo?: string;
  sortField?: string;
  sortOrder?: number;
  subject?: string;
}

export const emptyInboxMessageCriteria: InboxMessageCriteria = {
  page: 0,
  size: 10,
  sortField: 'sendDate',
  sortOrder: -1,
};
